export const SET_IS_DRAWER_OPEN = 'SET_IS_DRAWER_OPEN';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_TASK_ID = 'SET_TASK_ID';
export const SET_ORIGIN_MODAL = 'SET_ORIGIN_MODAL';
export const SET_SCHEDULE_IMPACT_REQUEST_ITEMS =
  'SET_SCHEDULE_IMPACT_REQUEST_ITEMS';
export const SET_SCHEDULE_IMPACT_REQUEST_ITEM =
  'SET_SCHEDULE_IMPACT_REQUEST_ITEM';
export const SET_IS_IN_PREVIEW = 'SET_IS_IN_PREVIEW';
export const SET_ACTIVITIES_NO_APPLY_CHANGES =
  'SET_ACTIVITIES_NO_APPLY_CHANGES';
export const SET_REQUEST_ID = 'SET_REQUEST_ID';

export const ScheduleImpactRequestActions = {
  setIsDrawerOpen: (value) => ({
    type: SET_IS_DRAWER_OPEN,
    isDrawerOpen: value
  }),
  setIsModalOpen: (value) => ({
    type: SET_IS_MODAL_OPEN,
    isModalOpen: value
  }),
  setTaskId: (value) => ({
    type: SET_TASK_ID,
    taskId: value
  }),
  setOriginModal: (value) => ({
    type: SET_ORIGIN_MODAL,
    originModal: value
  }),
  setScheduleImpactRequestItems: (value) => ({
    type: SET_SCHEDULE_IMPACT_REQUEST_ITEMS,
    scheduleImpactRequestItems: value
  }),
  setScheduleImpactRequestItem: (value) => ({
    type: SET_SCHEDULE_IMPACT_REQUEST_ITEM,
    scheduleImpactRequestItem: value
  }),
  setIsInPreview: (value) => ({
    type: SET_IS_IN_PREVIEW,
    isInPreview: value
  }),
  setActivitiesNoApplyChanges: (value) => ({
    type: SET_ACTIVITIES_NO_APPLY_CHANGES,
    activitiesNoApplyChanges: value
  }),
  setRequestId: (value) => ({
    type: SET_REQUEST_ID,
    requestId: value
  })
};
